import { useDispatch } from "react-redux";
import {
  toggleLoadingAboutMeSurveys,
  updateAboutMeSurveysList,
  toggleLoadingAboutMyClassesSurveys,
  updateAboutMyClassesSurveysList,
} from "../../store/actions/dataEntryMySurveysActions";
import { getMySurveysAboutMe as getMySurveysAboutMeService,
  getMySurveysAboutMyClasses as getMySurveysAboutMyClassesService,
 } from "../../services/data-entry/surveys.service";
import { useSnackbar } from "notistack";
import { useCallback } from "react";
import { handlerErrorV2 } from "../../utils/errors";
const useMySurveys = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const getMySurveysAboutMe = useCallback(async (skip, rowsPerPage, filter) => {
    dispatch(toggleLoadingAboutMeSurveys(true));
    try {
      const filterData = filter;
      const response = await getMySurveysAboutMeService(
        skip,
        rowsPerPage,
        filterData
      );
      if (!response?.data && response?.error) {
        enqueueSnackbar(response.error.message || "An error ocurred", {
          variant: "error",
        });
      } else {
        dispatch(
          updateAboutMeSurveysList(
            response?.data || { data: [], count: 0 }
          )
        );
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      dispatch(updateAboutMeSurveysList({ data: [], count: 0 }));
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      dispatch(toggleLoadingAboutMeSurveys(false));
    }
  }, []);

  const getMySurveysAboutMyClasses = useCallback(
    async (skip, rowsPerPage, filter) => {
      dispatch(toggleLoadingAboutMyClassesSurveys(true));
      try {
        const filterData = filter;
        const response = await getMySurveysAboutMyClassesService(
          skip,
          rowsPerPage,
          filterData
        );
        if (!response?.data && response?.error) {
          enqueueSnackbar(response.error.message || "An error ocurred", {
            variant: "error",
          });
        } else {
          dispatch(
            updateAboutMyClassesSurveysList(
              response?.data || { data: [], count: 0 }
            )
          );
        }
      } catch (error) {
        const message = handlerErrorV2(error);
        dispatch(updateAboutMyClassesSurveysList({ data: [], count: 0 }));
        enqueueSnackbar(message, { variant: "error" });
      } finally {
        dispatch(toggleLoadingAboutMyClassesSurveys(false));
      }
    },
    []
  );

  const onShareLink = (surveyId, row) => {
    navigator.clipboard.writeText(
      `${window.location.origin}/dashboard/data-entry/my-surveys/${surveyId}/fill-a-survey-about/${row._id}`
    );
    enqueueSnackbar('Copied to clipboard', { variant: 'success' });
  };

  return {
    getMySurveysAboutMe,
    getMySurveysAboutMyClasses,
    onShareLink,
  };
};

export default useMySurveys;
